<template>
  <div
    v-show="remainingSeconds !== null"
  >
    <ui-alert
      v-if="!expired" type="info"
    >
      <template
        v-slot:description
      >
          <span
            v-if="isUpdate"
          >
            {{ i18nComputed.updateDescription }}
          </span>
        <span
          v-else
        >
        {{ i18nComputed.updateDescriptionWithLink }}
        <a @click.stop.prevent='openEdit'>{{ i18n.editTheAd }}</a>
           </span>
      </template>
    </ui-alert>
  </div>
</template>
<script>
// import Translations from "./insert-me-to-translate.vue";

import Url from "domurl";

const blockedEditCookieName = 'promoted_post_blocked_editing';
const UPDATE_INTERVAL_MS = 1000;

export default {
  name: "PromotedPostEditCountdown",
  props: {
    editLimitTimestampSeconds: {
      type: Number,
      required: false,
      default: 0,
      validator: (value) => {
        return Number.isInteger(value) && value >= 0;
      }
    },
    activePromotionLightboxText: {
      type: String,
      required: true,
    },
    postPrivateCode: {
      type: String,
      required: true,
    },
    postEditUrl: {
      type: String,
      required: true,
    },
    isUpdate: {
      type: Boolean,
      default: false,
    }
  },
  components: {
    UiAlert: () => import(/* webpackChunkName: "chunk-ui-alert" */ './ui/ui-alert.vue'),
  },
  data() {
    return {
      intervalId: null,
      remainingSeconds: null,
      i18n: {
        editTheAd: gettext("edit the ad"),
      }

    }
  },

  created() {
    this.updateRemainingTime();
    this.intervalId = setInterval(this.updateRemainingTime, UPDATE_INTERVAL_MS);
  },

  beforeDestroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  },

  mounted() {
    const blockedEdit = this.$cookies.get(blockedEditCookieName);
    if (blockedEdit && blockedEdit === this.postPrivateCode) {
      this.$store.dispatch("ui/lightbox/show", {
        title: gettext("Error"),
        body: this.activePromotionLightboxText,
      });
      this.$cookies.remove(blockedEditCookieName, null, locations.cookie_domain);
    }
  },

  computed: {
    expired() {
      return Number.isInteger(this.remainingSeconds) && this.remainingSeconds < 0;
    },

    minutesLabel() {
      const minutesStr = Math.floor(this.remainingSeconds / 60).toString();
      if (minutesStr.length == 1) {
        return "0" + minutesStr;
      }
      return minutesStr;
    },
    i18nComputed() {
      return {
        updateDescription: interpolate(
          gettext('You still have %s min %s sec to edit the ad'),
          [this.minutesLabel, this.secondsLabel]
        ),
        updateDescriptionWithLink: interpolate(gettext("You still have %s min %s sec to"),
          [this.minutesLabel, this.secondsLabel])
      };
    },
    secondsLabel() {
      return ("0" + Math.floor(this.remainingSeconds % 60)).slice(-2);
    },
  },

  methods: {
    openEdit() {
      const currentUrl = new Url();
      const redirectUrl = new Url(this.postEditUrl);

      if (currentUrl.path === redirectUrl.path) {
        // same page, do nothing
        return;
      }

      // add next query string parameter
      redirectUrl.query.next = currentUrl;

      window.location.href = redirectUrl;
    },

    updateRemainingTime() {
      const remaining = Math.round(this.editLimitTimestampSeconds - Date.now() / 1000);
      this.remainingSeconds = remaining;
      
      if (remaining < 0 && this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = null;
      }
    }
  },
}
</script>
